import CalendarNode from 'src/components/flowchart/nodes/Calendar/CalendarNode';
import CallMeNode from 'src/components/flowchart/nodes/CallMe/CallMeNode';
import DisconnectNode from 'src/components/flowchart/nodes/Disconnect/DisconnectNode';
import EntryNode from 'src/components/flowchart/nodes/Entry/EntryNode';
import ForwardNode from 'src/components/flowchart/nodes/Forward/ForwardNode';
import HuntNode from 'src/components/flowchart/nodes/Hunt/HuntNode';
import IsExternalNode from 'src/components/flowchart/nodes/IsExternal/IsExternalNode';
import IsFromQueueNode from 'src/components/flowchart/nodes/IsFromQueue/IsFromQueueNode';
import MappingNode from 'src/components/flowchart/nodes/Mapping/MappingNode';
import PersonalVoicemailNode from 'src/components/flowchart/nodes/PersonalVoicemail/PersonalVoicemailNode';
import PresenceRouterNode from 'src/components/flowchart/nodes/PresenceRouter/PresenceRouterNode';
import QueueNode from 'src/components/flowchart/nodes/Queue/QueueNode';
import ResponseRouterNode from 'src/components/flowchart/nodes/ResponseRouter/ResponseRouterNode';
import UserNode from 'src/components/flowchart/nodes/User/UserNode';

import type { NodeTypes } from '@xyflow/react';

const callflowNodeTypes: NodeTypes = {
  call_me: CallMeNode as NodeTypes['call_me'],
  calendar: CalendarNode as NodeTypes['calendar'],
  disconnect: DisconnectNode as NodeTypes['disconnect'],
  entry: EntryNode as NodeTypes['entry'],
  forward: ForwardNode as NodeTypes['forward'],
  hunt: HuntNode as NodeTypes['hunt'],
  is_external: IsExternalNode as NodeTypes['is_external'],
  is_from_queue: IsFromQueueNode as NodeTypes['is_from_queue'],
  mapping: MappingNode as NodeTypes['mapping'],
  presence_router: PresenceRouterNode as NodeTypes['presence_router'],
  queue: QueueNode as NodeTypes['queue'],
  response_router: ResponseRouterNode as NodeTypes['response_router'],
  user: UserNode as NodeTypes['user'],
  personal_voicemail: PersonalVoicemailNode as NodeTypes['personal_voicemail'],
};

export default callflowNodeTypes;
